module.exports = __webpack_public_path__ + "static/barlow-semibold-webfont-c5884c03da98e02b0dc5907ba392f994.woff2";